<template>
    <div class="firstRecharge_main">
    <CustomHeader :text="$t('activityName.first_recharge')" :show-history="true" @openHistoryPopup="openHistoryPopup" />
        <img class="bg-top-img" :src="dataSet.bannerIcon">
        <div class="firstRecharge">{{ $t('activity.firstRecharge') + ': ' +
            formatCurrency(dataSet.firstRechargeAmount) }}</div>
        <div class="container">
            <img v-if="dataSet.showLeft" src="@/assets/home/game_arrow_white.png"
                style="width: 5%;position: absolute;top: 2vh; z-index: 200;" @click="scrollLeft">
            <img v-if="dataSet.showRight" src="@/assets/home/game_arrow_white.png" @click="scrollRight"
                style="width: 5%;position: absolute;transform: rotate(180deg);right:0;top: 2vh; z-index: 200;">
            <div v-if="dataSet.recordList.length > 0">
                <div class="content">
                    <div v-for="(i, index) in dataSet.recordList" :key="index" class="image-wrapper">
                        <DayList :currenyLable="true" :valueOne="i?.coin" :valueTwo="i?.turnover"
                            :labelOne="'dayList.giftAmount'" :labelTwo="'dayList.turnoverTimes'" :activityStatus="i?.status"
                            :time="i?.rewardDate" @getClaim="getClaim" :available-amount="i?.availableAmount"
                            :given-amount="i?.givenAmount" />
                    </div>
                </div>
            </div>
            <van-tabs v-if="dataSet.isShowTabs" v-model:active="active" sticky :ellipsis="false" ref="tabsRef"
                @rendered="checkScroll">
                <van-tab v-for="(item, index) in dataSet.firstRechargeConfig?.config" :key="index" :title="item.title"
                    :name="index">
                    <div class="content">
                        <div class="immidiateDepositBtn">
                            <div class="depositBtn" @click="goToDeposit(item.amount)"> {{ $t('activity.immediateDeposit') }}
                                : {{ item.amount }}</div>
                        </div>
                        <div v-for="(i, index) in item.days" :key="index" class="image-wrapper">
                            <DayList :currenyLable="true" :day="i.day" :valueOne="i.gift ? i.gift : 0"
                                :valueTwo="i.turnover_times" :labelOne="'dayList.giftAmount'"
                                :labelTwo="'dayList.turnoverTimes'" :activityStatus="i.activeStatus" />
                        </div>
                    </div>
                </van-tab>
            </van-tabs>
            <div v-else v-for="(item, index) in dataSet.firstRechargeConfig?.config" :key="index" :title="item?.title"
                :name="index">
                <div class="content">
                    <div v-for="(i, index) in item?.days" :key="index" class="image-wrapper">
                        <DayList :currenyLable="true" :day="i?.day" :valueOne="i?.gift ? i?.gift : 0"
                            :valueTwo="i?.turnover_times" :labelOne="'dayList.giftAmount'"
                            :labelTwo="'dayList.turnoverTimes'" :activityStatus="i?.activeStatus" />
                    </div>
                </div>
            </div>
            <NoData v-if="!dataSet.firstRechargeConfig && dataSet.recordList.length == 0" />
        <div class="bottom_text card">
            <div class="ruleHeader">
                    <img class="side-icon" src="@/assets/firstRecharge/tittleLine.png" />
                    <div class="title">{{ $t('common.activityTitle') }}</div>
                    <img class="side-icon flipped" src="@/assets/firstRecharge/tittleLine.png" />
                </div>

                <div class="rules-content">
                    <div class="line_text" v-for="(item, index) in dataSet.formattedMessages" :key="index" v-html="item">
                    </div>
                </div>
            </div>
            <CashbackHistoryPopup ref="histryPopupRef" :list="dataSet.historyList" :title="$t('activity.lossTotal')"
                @resetHistoryData="resetHistoryData" :isUseFirstRecharge="true" />
        </div>
    </div>
    
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { formatCurrency } from '@/utils/commonFunction';
import CustomHeader from '../components/common/customHeader.vue';
import DayList from '../components/common/dayList.vue';
import NoData from '../components/common/noDataCustom.vue';
import CashbackHistoryPopup from '../components/common/cashbackHistoryPopup.vue';
import { FirstRechargeData } from '@/view/firstRecharge/supportScript';


const histryPopupRef = ref()
const active = ref(0);
const props = defineProps<{
    dataSet: FirstRechargeData
}>()

const emits = defineEmits(['checkScroll', 'scrollLeft', 'scrollRight', 'getClaim', 'goToDeposit'])

const setActive = (value: number) => {
    active.value = value
}

const checkScroll = () => {
    emits('checkScroll')
};

const scrollLeft = () => {
    emits('scrollLeft')
};

const scrollRight = () => {
    emits('scrollRight')
};

const getClaim = () => {
    emits('getClaim')
}
const goToDeposit = (amount: any) => {
    emits("goToDeposit", amount)
    localStorage.setItem('showDepositBackIcon', '1')
}
const openHistoryPopup = (data: any) => {
    histryPopupRef.value.open(data)
}
const resetHistoryData = () => {
    // historyList.value = []
}
defineExpose({
    setActive
})
</script>
<style scoped>
.firstRecharge_main{
    min-height: 100vh;
    background: #090f1f;
    padding: 60px 0;
}
.firstRecharge {
    padding: 10px 30px;
    color:  #ffffff;
    font-weight: 600;
    font-size: 20px;
}

.container {
    padding: 0px;
    position: relative;
    height: auto;

}
.container >>> .van-tabs__wrap {
    height: auto; 
    padding: 10px 0;
}

:deep(.van-tabs__line) { 
  background-color: #38a8fa;
  height: 3px;              
  border-radius: 2px;     
  bottom: 0px;             
}

:deep(.van-tabs__nav--line) {
  padding-bottom: 0;
}

:deep(.van-tab) {
  padding: 0 10px; }

.container>>>.van-tabs__nav {
    background: transparent;
    margin: 0;
    padding: 0;

}
.container :deep(.van-tabs) {
    --van-tab-active-text-color: #38a8fa;
}

.container :deep(.van-tab--active .van-tab__text) {
    color: #38a8fa !important;
}
.container>>>.van-tab {
    background: transparent;
    color:  9;
    font-size: 18px;
    margin: 0px;
    height: 40px;
    font-weight: 500;
    padding: 0 20px;
    border: none;
    transition: 0.3s;
    width:fit-content;
}

.container>>>.van-tab.van-tab--active {
    color: #fff;
    font-weight: 500;
    
}

.container >>> .van-tab--active, .container >>> .van-tab {
    border-radius: 0;
}

.content {
    color: #fff;
    padding: 15px;
}

.bottom_text.card {
    padding: 15px;
    max-width: 500px;
}

.ruleHeader {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 10px;
    .ruleHeader {
    position: relative;
    z-index: 10;
}
}

.side-icon {
    width: 60px;
    height: auto;
    display: block;
}

.flipped {
    transform: scaleX(-1);
}
.title {
    color: #ffffff;
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    white-space: nowrap;
}

.line_text {
    color: #7485aa;
    font-size: 18px;
    padding: 10px;
}

.bg-top-img {
    width: 100%;
}

.immidiateDepositBtn {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
}

.depositBtn {
    color: #cc3300;
    font-weight: bold;
    font-size: 18px;
    background: linear-gradient(90deg, #e9c986 0%, #d8bf83 50%, #d8a841 100%);
    border-radius: 10px;
    padding: 10px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 30px;
    align-items: center;
    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.4);
    cursor: pointer;
}

.depositBtn:hover {
    background: linear-gradient(90deg, #ffdc8a 0%, #f7c95e 50%, #ffc133 100%);
    transform: translateY(0px);
    color: #cc3300; 
    }

.depositBtn:active {
    transform: translateY(1px);
    box-shadow: 0 0 5px rgba(255, 215, 0, 0.4);
}

@media screen and (max-width: 360px) {
    .firstRecharge {
        padding: 8px 15px;
        font-size: 15px;
        text-align: left;
    }

    .container :deep(.van-tab) {
        font-size: 14px;
        padding: 0 10px;
        height: 36px;
        min-width: 60px;
    }

    .depositBtn {
        font-size: 15px;
        height: auto;
        min-height: 35px;
        padding: 6px 10px;
        width: 90%;
        margin: 0 auto;
    }

    .line_text {
        color: #7485aa;
        font-size: 14px;
        padding: 10px;
    }

    .side-icon {
        width: 30px;
    }

    .title {
        font-size: 15px;
    }

}
</style>